/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { AddQuizsetFolderItemReq } from '../_model/addQuizsetFolderItemReq';
import type { CreateQuizsetFolderReq } from '../_model/createQuizsetFolderReq';
import type { CursorSearchResponseListSearchQuizsetFolderRes } from '../_model/cursorSearchResponseListSearchQuizsetFolderRes';
import type { DeleteQuizsetFolderReq } from '../_model/deleteQuizsetFolderReq';
import type { GetParams } from '../_model/getParams';
import type { GetSitemapEntriesParams } from '../_model/getSitemapEntriesParams';
import type { ListMineParams } from '../_model/listMineParams';
import type { QuizsetFolderCursorSearchReq } from '../_model/quizsetFolderCursorSearchReq';
import type { QuizsetFolderPlayNextReq } from '../_model/quizsetFolderPlayNextReq';
import type { QuizsetFolderPlayStartReq } from '../_model/quizsetFolderPlayStartReq';
import type { ReorderQuizsetFolderItemsReq } from '../_model/reorderQuizsetFolderItemsReq';
import type { SuccessBody } from '../_model/successBody';
import type { SuccessBodyListString } from '../_model/successBodyListString';
import type { SuccessBodyQuizsetFolderCursorPage } from '../_model/successBodyQuizsetFolderCursorPage';
import type { SuccessBodyQuizsetFolderNextRes } from '../_model/successBodyQuizsetFolderNextRes';
import type { SuccessBodyQuizsetFolderPlayStartRes } from '../_model/successBodyQuizsetFolderPlayStartRes';
import type { SuccessBodyQuizsetFolderRes } from '../_model/successBodyQuizsetFolderRes';
import type { SuccessBodySeoSitemapPageQuizsetFolderSitemapEntry } from '../_model/successBodySeoSitemapPageQuizsetFolderSitemapEntry';
import type { UpdateQuizsetFolderNameReq } from '../_model/updateQuizsetFolderNameReq';
import type { UpdateQuizsetFolderReq } from '../_model/updateQuizsetFolderReq';
import type { UpdateQuizsetFolderVisibilityReq } from '../_model/updateQuizsetFolderVisibilityReq';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const searchPublic = (
  userId: string,
  quizsetFolderCursorSearchReq: BodyType<QuizsetFolderCursorSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<CursorSearchResponseListSearchQuizsetFolderRes>(
    {
      url: `/users/${userId}/quizset-folders/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetFolderCursorSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchPublicMutationKey = () => ['searchPublic'] as const;

export const getSearchPublicMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchPublic>>,
    TError,
    SearchPublicMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchPublic>>,
  TError,
  SearchPublicMutationVariables,
  TContext
> => {
  const mutationKey = getSearchPublicMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchPublic>>,
    SearchPublicMutationVariables
  > = props => {
    const { userId, data } = props ?? {};

    return searchPublic(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchPublicMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchPublic>>
>;
export type SearchPublicMutationBody = BodyType<QuizsetFolderCursorSearchReq>;
export type SearchPublicMutationError = ErrorType<unknown>;
export type SearchPublicMutationVariables = {
  userId: string;
  data: BodyType<QuizsetFolderCursorSearchReq>;
};

export const useSearchPublic = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchPublic>>,
      TError,
      SearchPublicMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchPublic>>,
  TError,
  SearchPublicMutationVariables,
  TContext
> => {
  return useMutation(getSearchPublicMutationOptions(options), queryClient);
};
export const create = (
  createQuizsetFolderReq: BodyType<CreateQuizsetFolderReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createQuizsetFolderReq,
      signal,
    },
    options,
  );
};

export const getCreateMutationKey = () => ['create'] as const;

export const getCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof create>>,
    TError,
    CreateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof create>>,
  TError,
  CreateMutationVariables,
  TContext
> => {
  const mutationKey = getCreateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof create>>,
    CreateMutationVariables
  > = props => {
    const { data } = props ?? {};

    return create(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof create>>
>;
export type CreateMutationBody = BodyType<CreateQuizsetFolderReq>;
export type CreateMutationError = ErrorType<unknown>;
export type CreateMutationVariables = {
  data: BodyType<CreateQuizsetFolderReq>;
};

export const useCreate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof create>>,
      TError,
      CreateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof create>>,
  TError,
  CreateMutationVariables,
  TContext
> => {
  return useMutation(getCreateMutationOptions(options), queryClient);
};
export const start = (
  id: string,
  quizsetFolderPlayStartReq?: BodyType<QuizsetFolderPlayStartReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderPlayStartRes>(
    {
      url: `/quizset-folders/${id}/play/start`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetFolderPlayStartReq,
      signal,
    },
    options,
  );
};

export const getStartMutationKey = () => ['start'] as const;

export const getStartMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof start>>,
    TError,
    StartMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof start>>,
  TError,
  StartMutationVariables,
  TContext
> => {
  const mutationKey = getStartMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof start>>,
    StartMutationVariables
  > = props => {
    const { id, data } = props ?? {};

    return start(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartMutationResult = NonNullable<
  Awaited<ReturnType<typeof start>>
>;
export type StartMutationBody = BodyType<QuizsetFolderPlayStartReq> | undefined;
export type StartMutationError = ErrorType<unknown>;
export type StartMutationVariables = {
  id: string;
  data?: BodyType<QuizsetFolderPlayStartReq>;
};

export const useStart = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof start>>,
      TError,
      StartMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof start>>,
  TError,
  StartMutationVariables,
  TContext
> => {
  return useMutation(getStartMutationOptions(options), queryClient);
};
export const next = (
  id: string,
  quizsetFolderPlayNextReq: BodyType<QuizsetFolderPlayNextReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderNextRes>(
    {
      url: `/quizset-folders/${id}/play/next`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetFolderPlayNextReq,
      signal,
    },
    options,
  );
};

export const getNextMutationKey = () => ['next'] as const;

export const getNextMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof next>>,
    TError,
    NextMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof next>>,
  TError,
  NextMutationVariables,
  TContext
> => {
  const mutationKey = getNextMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof next>>,
    NextMutationVariables
  > = props => {
    const { id, data } = props ?? {};

    return next(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NextMutationResult = NonNullable<Awaited<ReturnType<typeof next>>>;
export type NextMutationBody = BodyType<QuizsetFolderPlayNextReq>;
export type NextMutationError = ErrorType<unknown>;
export type NextMutationVariables = {
  id: string;
  data: BodyType<QuizsetFolderPlayNextReq>;
};

export const useNext = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof next>>,
      TError,
      NextMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof next>>,
  TError,
  NextMutationVariables,
  TContext
> => {
  return useMutation(getNextMutationOptions(options), queryClient);
};
export const addItem = (
  id: string,
  addQuizsetFolderItemReq: BodyType<AddQuizsetFolderItemReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}/items`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addQuizsetFolderItemReq,
      signal,
    },
    options,
  );
};

export const getAddItemMutationKey = () => ['addItem'] as const;

export const getAddItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addItem>>,
    TError,
    AddItemMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addItem>>,
  TError,
  AddItemMutationVariables,
  TContext
> => {
  const mutationKey = getAddItemMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addItem>>,
    AddItemMutationVariables
  > = props => {
    const { id, data } = props ?? {};

    return addItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof addItem>>
>;
export type AddItemMutationBody = BodyType<AddQuizsetFolderItemReq>;
export type AddItemMutationError = ErrorType<unknown>;
export type AddItemMutationVariables = {
  id: string;
  data: BodyType<AddQuizsetFolderItemReq>;
};

export const useAddItem = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addItem>>,
      TError,
      AddItemMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addItem>>,
  TError,
  AddItemMutationVariables,
  TContext
> => {
  return useMutation(getAddItemMutationOptions(options), queryClient);
};
export const searchMine = (
  quizsetFolderCursorSearchReq: BodyType<QuizsetFolderCursorSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<CursorSearchResponseListSearchQuizsetFolderRes>(
    {
      url: `/quizset-folders/my/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetFolderCursorSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchMineMutationKey = () => ['searchMine'] as const;

export const getSearchMineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMine>>,
    TError,
    SearchMineMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchMine>>,
  TError,
  SearchMineMutationVariables,
  TContext
> => {
  const mutationKey = getSearchMineMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchMine>>,
    SearchMineMutationVariables
  > = props => {
    const { data } = props ?? {};

    return searchMine(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchMineMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchMine>>
>;
export type SearchMineMutationBody = BodyType<QuizsetFolderCursorSearchReq>;
export type SearchMineMutationError = ErrorType<unknown>;
export type SearchMineMutationVariables = {
  data: BodyType<QuizsetFolderCursorSearchReq>;
};

export const useSearchMine = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchMine>>,
      TError,
      SearchMineMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchMine>>,
  TError,
  SearchMineMutationVariables,
  TContext
> => {
  return useMutation(getSearchMineMutationOptions(options), queryClient);
};
export const get = (
  id: string,
  params?: GetParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    { url: `/quizset-folders/${id}`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQueryKey = (id: string, params?: GetParams) => {
  return [`/quizset-folders/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetQueryOptions = <
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof get>>> = ({
    signal,
  }) => get(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetQueryResult = NonNullable<Awaited<ReturnType<typeof get>>>;
export type GetQueryError = ErrorType<unknown>;

export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: undefined | GetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof get>>> = ({
    signal,
  }) => get(id, params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof get>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof get>>
>;
export type GetSuspenseQueryError = ErrorType<unknown>;

export function useGetSuspense<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: undefined | GetParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuspense<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuspense<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSuspense<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const _delete = (
  id: string,
  deleteQuizsetFolderReq?: BodyType<DeleteQuizsetFolderReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBody>(
    {
      url: `/quizset-folders/${id}`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: deleteQuizsetFolderReq,
      signal,
    },
    options,
  );
};

export const getDeleteMutationKey = () => ['_delete'] as const;

export const getDeleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof _delete>>,
    TError,
    _DeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof _delete>>,
  TError,
  _DeleteMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof _delete>>,
    _DeleteMutationVariables
  > = props => {
    const { id, data } = props ?? {};

    return _delete(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type _DeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof _delete>>
>;
export type _DeleteMutationBody = BodyType<DeleteQuizsetFolderReq> | undefined;
export type _DeleteMutationError = ErrorType<unknown>;
export type _DeleteMutationVariables = {
  id: string;
  data?: BodyType<DeleteQuizsetFolderReq>;
};

export const useDelete = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof _delete>>,
      TError,
      _DeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof _delete>>,
  TError,
  _DeleteMutationVariables,
  TContext
> => {
  return useMutation(getDeleteMutationOptions(options), queryClient);
};
export const update = (
  id: string,
  updateQuizsetFolderReq: BodyType<UpdateQuizsetFolderReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateQuizsetFolderReq,
      signal,
    },
    options,
  );
};

export const getUpdateMutationKey = () => ['update'] as const;

export const getUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof update>>,
    TError,
    UpdateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof update>>,
  TError,
  UpdateMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof update>>,
    UpdateMutationVariables
  > = props => {
    const { id, data } = props ?? {};

    return update(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof update>>
>;
export type UpdateMutationBody = BodyType<UpdateQuizsetFolderReq>;
export type UpdateMutationError = ErrorType<unknown>;
export type UpdateMutationVariables = {
  id: string;
  data: BodyType<UpdateQuizsetFolderReq>;
};

export const useUpdate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof update>>,
      TError,
      UpdateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof update>>,
  TError,
  UpdateMutationVariables,
  TContext
> => {
  return useMutation(getUpdateMutationOptions(options), queryClient);
};
export const updateVisibility = (
  id: string,
  updateQuizsetFolderVisibilityReq: BodyType<UpdateQuizsetFolderVisibilityReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}/visibility`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateQuizsetFolderVisibilityReq,
      signal,
    },
    options,
  );
};

export const getUpdateVisibilityMutationKey = () =>
  ['updateVisibility'] as const;

export const getUpdateVisibilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVisibility>>,
    TError,
    UpdateVisibilityMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVisibility>>,
  TError,
  UpdateVisibilityMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateVisibilityMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVisibility>>,
    UpdateVisibilityMutationVariables
  > = props => {
    const { id, data } = props ?? {};

    return updateVisibility(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVisibility>>
>;
export type UpdateVisibilityMutationBody =
  BodyType<UpdateQuizsetFolderVisibilityReq>;
export type UpdateVisibilityMutationError = ErrorType<unknown>;
export type UpdateVisibilityMutationVariables = {
  id: string;
  data: BodyType<UpdateQuizsetFolderVisibilityReq>;
};

export const useUpdateVisibility = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateVisibility>>,
      TError,
      UpdateVisibilityMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateVisibility>>,
  TError,
  UpdateVisibilityMutationVariables,
  TContext
> => {
  return useMutation(getUpdateVisibilityMutationOptions(options), queryClient);
};
export const updateName = (
  id: string,
  updateQuizsetFolderNameReq: BodyType<UpdateQuizsetFolderNameReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}/name`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateQuizsetFolderNameReq,
      signal,
    },
    options,
  );
};

export const getUpdateNameMutationKey = () => ['updateName'] as const;

export const getUpdateNameMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateName>>,
    TError,
    UpdateNameMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateName>>,
  TError,
  UpdateNameMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateNameMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateName>>,
    UpdateNameMutationVariables
  > = props => {
    const { id, data } = props ?? {};

    return updateName(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateName>>
>;
export type UpdateNameMutationBody = BodyType<UpdateQuizsetFolderNameReq>;
export type UpdateNameMutationError = ErrorType<unknown>;
export type UpdateNameMutationVariables = {
  id: string;
  data: BodyType<UpdateQuizsetFolderNameReq>;
};

export const useUpdateName = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateName>>,
      TError,
      UpdateNameMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateName>>,
  TError,
  UpdateNameMutationVariables,
  TContext
> => {
  return useMutation(getUpdateNameMutationOptions(options), queryClient);
};
export const reorderItems = (
  id: string,
  reorderQuizsetFolderItemsReq: BodyType<ReorderQuizsetFolderItemsReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}/items/order`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: reorderQuizsetFolderItemsReq,
      signal,
    },
    options,
  );
};

export const getReorderItemsMutationKey = () => ['reorderItems'] as const;

export const getReorderItemsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderItems>>,
    TError,
    ReorderItemsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderItems>>,
  TError,
  ReorderItemsMutationVariables,
  TContext
> => {
  const mutationKey = getReorderItemsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderItems>>,
    ReorderItemsMutationVariables
  > = props => {
    const { id, data } = props ?? {};

    return reorderItems(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderItems>>
>;
export type ReorderItemsMutationBody = BodyType<ReorderQuizsetFolderItemsReq>;
export type ReorderItemsMutationError = ErrorType<unknown>;
export type ReorderItemsMutationVariables = {
  id: string;
  data: BodyType<ReorderQuizsetFolderItemsReq>;
};

export const useReorderItems = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderItems>>,
      TError,
      ReorderItemsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reorderItems>>,
  TError,
  ReorderItemsMutationVariables,
  TContext
> => {
  return useMutation(getReorderItemsMutationOptions(options), queryClient);
};
export const getSitemapEntries = (
  params: GetSitemapEntriesParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodySeoSitemapPageQuizsetFolderSitemapEntry>(
    { url: `/quizset-folders/sitemap-entries`, method: 'GET', params, signal },
    options,
  );
};

export const getGetSitemapEntriesQueryKey = (
  params?: GetSitemapEntriesParams,
) => {
  return [
    `/quizset-folders/sitemap-entries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSitemapEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSitemapEntriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSitemapEntries>>
  > = ({ signal }) => getSitemapEntries(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSitemapEntries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSitemapEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSitemapEntries>>
>;
export type GetSitemapEntriesQueryError = ErrorType<unknown>;

export function useGetSitemapEntries<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitemapEntries>>,
          TError,
          Awaited<ReturnType<typeof getSitemapEntries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitemapEntries<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitemapEntries>>,
          TError,
          Awaited<ReturnType<typeof getSitemapEntries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitemapEntries<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSitemapEntries<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSitemapEntriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSitemapEntriesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSitemapEntriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSitemapEntries>>
  > = ({ signal }) => getSitemapEntries(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSitemapEntries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetSitemapEntriesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSitemapEntries>>
>;
export type GetSitemapEntriesSuspenseQueryError = ErrorType<unknown>;

export function useGetSitemapEntriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitemapEntriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitemapEntriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSitemapEntriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSitemapEntriesSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSitemapCountries = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListString>(
    { url: `/quizset-folders/sitemap-countries`, method: 'GET', signal },
    options,
  );
};

export const getGetSitemapCountriesQueryKey = () => {
  return [`/quizset-folders/sitemap-countries`] as const;
};

export const getGetSitemapCountriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSitemapCountries>>
  > = ({ signal }) => getSitemapCountries(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSitemapCountriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSitemapCountries>>
>;
export type GetSitemapCountriesQueryError = ErrorType<unknown>;

export function useGetSitemapCountries<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitemapCountries<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitemapCountries<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSitemapCountries<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSitemapCountriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSitemapCountriesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSitemapCountries>>
  > = ({ signal }) => getSitemapCountries(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetSitemapCountriesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSitemapCountries>>
>;
export type GetSitemapCountriesSuspenseQueryError = ErrorType<unknown>;

export function useGetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSitemapCountriesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const listMine = (
  params?: ListMineParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderCursorPage>(
    { url: `/quizset-folders/my`, method: 'GET', params, signal },
    options,
  );
};

export const getListMineQueryKey = (params?: ListMineParams) => {
  return [`/quizset-folders/my`, ...(params ? [params] : [])] as const;
};

export const getListMineQueryOptions = <
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMineQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMine>>> = ({
    signal,
  }) => listMine(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMineQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMine>>
>;
export type ListMineQueryError = ErrorType<unknown>;

export function useListMine<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ListMineParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMine>>,
          TError,
          Awaited<ReturnType<typeof listMine>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMine<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMine>>,
          TError,
          Awaited<ReturnType<typeof listMine>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMine<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListMine<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListMineQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListMineSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMineQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMine>>> = ({
    signal,
  }) => listMine(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type ListMineSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMine>>
>;
export type ListMineSuspenseQueryError = ErrorType<unknown>;

export function useListMineSuspense<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ListMineParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMineSuspense<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMineSuspense<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListMineSuspense<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListMineSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const removeItem = (
  id: string,
  quizsetId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}/items/${quizsetId}`,
      method: 'DELETE',
      signal,
    },
    options,
  );
};

export const getRemoveItemMutationKey = () => ['removeItem'] as const;

export const getRemoveItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeItem>>,
    TError,
    RemoveItemMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeItem>>,
  TError,
  RemoveItemMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveItemMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeItem>>,
    RemoveItemMutationVariables
  > = props => {
    const { id, quizsetId } = props ?? {};

    return removeItem(id, quizsetId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeItem>>
>;

export type RemoveItemMutationError = ErrorType<unknown>;
export type RemoveItemMutationVariables = { id: string; quizsetId: string };

export const useRemoveItem = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeItem>>,
      TError,
      RemoveItemMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeItem>>,
  TError,
  RemoveItemMutationVariables,
  TContext
> => {
  return useMutation(getRemoveItemMutationOptions(options), queryClient);
};
